<template>
  <div>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          근무신청일
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{ mapPeriod }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          근무유형
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{
          GET_APP_MAP_DATA.workOrgNm
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          근무스케줄
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{ timeNm }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">비고</v-list-item-subtitle>
        <v-list-item-content class="app-desc">{{
          GET_APP_MAP_DATA.note
        }}</v-list-item-content>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import { getWorkOrgTimeList, getScheduleTimeOne } from '@/api/application';
import viewerMixin from '@/mixins/viewerMixin.js';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  mixins: [viewerMixin],
  data: () => ({
    timeList: [],
    timeNm: '',
  }),
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    ...mapGetters('CODE', ['GET_GNT_CD_NM']),
    // 기간
    mapPeriod() {
      return dayjs(this.GET_APP_MAP_DATA.ymd).format('YYYY-MM-DD');
    },
  },
  props: {
    appInfoParam: Object,
  },
  methods: {
    // 신청 상세 내용 조회
    async fetchApplicationMap() {
      this.ON_APP_SPINNER(); // 스피너 ON
      try {
        await this.$store.dispatch('ELA/FETCH_SCHEDULE_MAP', {
          searchApplSeq: this.appInfoParam.applSeq,
          searchApplSabun: this.appInfoParam.applSabun,
        });

        const response = await getScheduleTimeOne({
          searchApplSeq: this.appInfoParam.applSeq,
          searchApplSabun: this.appInfoParam.applSabun,
          sdate: this.GET_APP_MAP_DATA.sdate,
          edate: this.GET_APP_MAP_DATA.edate,
        });

        const timeCd = response.data.data[0].timeCd;
        this.timeList.forEach(timeObj => {
          if (timeObj.code === timeCd) {
            this.timeNm = timeObj.codeNm;
            return false;
          }
        });
        this.OFF_APP_SPINNER(); // 스피너 OFF
      } catch (error) {
        console.log(error);
        // this.OFF_APP_SPINNER(); // 스피너 OFF
      }
    },

    async fetchWorkOrgTimeList() {
      try {
        const response = await getWorkOrgTimeList();
        this.timeList = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    // console.log('ScheduleViewerData mounted');
    this.fetchWorkOrgTimeList();
    this.fetchApplicationMap();
  },
};
</script>

<style></style>
